export default { sha: 'da8ea90be93542c6e10b108cf265b74afff9fda6', buildNumber: 'undefined' }
